<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>{{ form.ruta }} - Base del {{ form.fecha }}</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <input-field
              vMoney
              :format="moneyNegative"
              v-model="form.saldo"
              id="saldo"
            >
              <span>Saldo</span>
              <span
                v-if="errores.saldo"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores.saldo[0] }}</strong>
              </span>
            </input-field>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button class="btn-success" type="button" @click="aceptar">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button
        @click="$emit('cancelar')"
        class="btn-danger btn--text"
        type="button"
      >
        <i class="fa fa-ban"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      form: this.value,
      errores: {},
      url: url,
      moneyNegative: moneyNegative,
    };
  },
  methods: {
    aceptar: function () {
      let urlRequest =
        this.url + "/logistica/bases-rutas/" + this.form.id;
      let that = this;
      axios
        .post(urlRequest, this.form)
        .then(function (response) {
          that.$emit('saved');
          swal(
            "Los saldos de la base han sido almacenados.",
            "Realizado",
            "success"
          );
        })
        .catch(function (error) {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) {
                that.errores = response.data.errors;
                swal("Hay validaciones por corregir.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/basesrutas/SaldoBase.vue